(function() {
  var DAY_NAMES_IS = ['Sunnudag', 'Mánudag', 'Þriðjudag', 'Miðvikudag', 'Fimmtudag', 'Föstudag', 'Laugardag'];

  // Parse a single hours string like "15:00 - 23:00" or "12:00 - 24:00" or "12:00 - 00:00"
  function parseHoursString(str) {
    if (!str) return null;
    var match = str.match(/(\d{1,2}):(\d{2})\s*[–\-]\s*(\d{1,2}):(\d{2})/);
    if (!match) return null;
    var openH = parseInt(match[1], 10);
    var openM = parseInt(match[2], 10);
    var closeH = parseInt(match[3], 10);
    var closeM = parseInt(match[4], 10);
    // Treat "00:00" close as "24:00" (midnight at end of day)
    if (closeH === 0 && closeM === 0) closeH = 24;
    return { openHour: openH, openMin: openM, closeHour: closeH, closeMin: closeM };
  }

  // Build OPENING_HOURS from metaobject data injected in theme.liquid
  var OPENING_HOURS = (function() {
    var src = window.OLFONG_OPENING_HOURS || {};
    var result = {};
    for (var day in src) {
      if (Object.prototype.hasOwnProperty.call(src, day)) {
        var parsed = parseHoursString(src[day]);
        if (parsed) result[day] = parsed;
      }
    }
    // Fallback if metaobject data isn't available
    if (Object.keys(result).length === 0) {
      console.warn('[olfong-pickup] No opening hours from metaobject — using fallback');
      result = {
        0: { openHour: 12, openMin: 0, closeHour: 23, closeMin: 0 },
        1: { openHour: 15, openMin: 0, closeHour: 23, closeMin: 0 },
        2: { openHour: 15, openMin: 0, closeHour: 23, closeMin: 0 },
        3: { openHour: 15, openMin: 0, closeHour: 23, closeMin: 0 },
        4: { openHour: 15, openMin: 0, closeHour: 23, closeMin: 0 },
        5: { openHour: 12, openMin: 0, closeHour: 24, closeMin: 0 },
        6: { openHour: 12, openMin: 0, closeHour: 24, closeMin: 0 }
      };
    }
    return result;
  })();

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function formatDate(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function formatTime(d) { return pad(d.getHours()) + ':' + pad(d.getMinutes()); }

  function roundUpToFive(date) {
    var minutes = date.getMinutes();
    var rounded = Math.ceil(minutes / 5) * 5;
    var result = new Date(date.getTime());
    if (rounded === 60) { result.setHours(result.getHours() + 1); result.setMinutes(0); }
    else { result.setMinutes(rounded); }
    result.setSeconds(0); result.setMilliseconds(0);
    return result;
  }

  function getHoursForDate(dateStr) {
    if (!dateStr) return null;
    var date = new Date(dateStr + 'T00:00:00');
    return OPENING_HOURS[date.getDay()] || null;
  }

  function clampToOpeningHours(date) {
    // Walk forward up to 8 days to find a valid open slot
    for (var attempt = 0; attempt < 8; attempt++) {
      var dayHours = OPENING_HOURS[date.getDay()];
      if (dayHours) {
        var openMinutes = dayHours.openHour * 60 + dayHours.openMin;
        var closeMinutes = dayHours.closeHour * 60 + dayHours.closeMin;
        var pickMinutes = date.getHours() * 60 + date.getMinutes();

        if (pickMinutes < openMinutes) {
          date.setHours(dayHours.openHour);
          date.setMinutes(dayHours.openMin);
          date.setSeconds(0);
          return date;
        }

        if (pickMinutes <= closeMinutes) {
          return date;
        }
      }

      date.setDate(date.getDate() + 1);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
    }
    return date;
  }

  function hasDateAndTime(picker) {
    var dateInput = picker.querySelector('[data-pickup-date]');
    var timeInput = picker.querySelector('[data-pickup-time]');
    return !!(dateInput && timeInput && dateInput.value && timeInput.value);
  }

  function isTimeWithinHours(picker) {
    var dateInput = picker.querySelector('[data-pickup-date]');
    var timeInput = picker.querySelector('[data-pickup-time]');
    if (!dateInput || !timeInput || !dateInput.value || !timeInput.value) return false;
    var dayHours = getHoursForDate(dateInput.value);
    if (!dayHours) return false;
    var parts = timeInput.value.split(':');
    var h = parseInt(parts[0], 10), m = parseInt(parts[1], 10);
    var pickMinutes = h * 60 + m;
    if (h === 0 && dayHours.closeHour === 24) pickMinutes = 24 * 60 + m;
    var openMinutes = dayHours.openHour * 60 + dayHours.openMin;
    var closeMinutes = dayHours.closeHour * 60 + dayHours.closeMin;
    if (pickMinutes < openMinutes || pickMinutes > closeMinutes) return false;
    return true;
  }

  function setTimeInPicker(picker, timeStr) {
    var timeInput = picker.querySelector('[data-pickup-time]');
    var hourSelect = picker.querySelector('[data-pickup-hour]');
    var minSelect = picker.querySelector('[data-pickup-minute]');
    if (timeInput) timeInput.value = timeStr;
    if (timeStr && hourSelect && minSelect) {
      var parts = timeStr.split(':');
      hourSelect.value = parts[0];
      minSelect.value = parts[1];
    }
  }

  // Consent now lives OUTSIDE the box (moved below the donation), so read it
  // document-wide.
  function consentIsChecked() {
    var checked = false;
    document.querySelectorAll('[data-pickup-consent]').forEach(function(c) { if (c.checked) checked = true; });
    return checked;
  }
  function refreshGate() {
    // Consent is now a passive notice (no checkbox), so there is nothing to gate:
    // when no consent checkbox exists on the page, checkout is always allowed.
    var hasBox = document.querySelectorAll('[data-pickup-consent]').length > 0;
    var ok = !hasBox || consentIsChecked();
    document.body.classList.toggle('olfong-pickup-blocked', !ok);
    document.querySelectorAll('[data-pickup-status]').forEach(function(status) {
      status.textContent = ok ? '' : 'Vinsamlegast hakaðu við reitinn hér að ofan til að halda áfram í greiðslu.';
      status.classList.remove('is-error', 'is-warning');
      if (!ok) status.classList.add('is-error');
    });
  }

  function updateUI(picker) {
    var dateInput = picker.querySelector('[data-pickup-date]');
    var timeInput = picker.querySelector('[data-pickup-time]');
    if (!dateInput || !timeInput) return;

    refreshGate();

    var noteInput = picker.querySelector('[data-pickup-note]');
    // Only record the pickup date/time when an actual time picker (hour select)
    // is shown. The closed-store box is now just a notice + WhatsApp link with
    // hidden inputs, so nothing is written for it.
    var timeDD = picker.querySelector('[data-pickup-time-dd]');
    var timeShown = timeDD && !timeDD.hidden && !!picker.querySelector('[data-pickup-hour]');
    var note = '';
    if (timeShown && dateInput.value) note += 'Pickup date: ' + dateInput.value;
    if (timeShown && timeInput.value) note += (note ? '\n' : '') + 'Pickup time: ' + timeInput.value;
    if (consentIsChecked()) note += (note ? '\n' : '') + 'Age & terms confirmed: yes';
    // Only add the back-pickup line to the order memo when the box is ticked.
    var backInput = picker.querySelector('[data-pickup-back]');
    if (backInput && backInput.checked) note += (note ? '\n' : '') + 'Sækja bakvið: JÁ';
    if (noteInput && noteInput.value.trim()) note += (note ? '\n' : '') + 'Comment: ' + noteInput.value.trim();
    var formData = new FormData();
    formData.append('note', note);
    fetch('/cart/update.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    }).catch(function() {});
  }

 function fillPicker(picker) {
  if (!picker) return;
  var dateInput = picker.querySelector('[data-pickup-date]');
  var timeInput = picker.querySelector('[data-pickup-time]');
  if (!dateInput || !timeInput) return;

  try { dateInput.min = formatDate(new Date()); } catch (e) {}

  if (!dateInput.value || !timeInput.value) {
  var target = roundUpToFive(new Date());
  // No clamping — user gets current time as default
  dateInput.value = formatDate(target);
  setTimeInPicker(picker, formatTime(target));
    // Mark "Sem fyrst" (preset 0) as active by default
    picker.querySelectorAll('[data-preset]').forEach(function(b) {
      b.classList.toggle('is-active', parseInt(b.dataset.preset, 10) === 0);
    });
  }
  // NOTE: do not call updateUI() here — it would write the (still-empty)
  // consent/comment over the saved order note on a fresh re-render. The note is
  // written after restoreFromCart() runs (see fillAll).
}

  // Is the store open right now? (Same day-of-week hours the opening bar uses.)
  function isStoreOpenNow() {
    var now = new Date();
    var hours = OPENING_HOURS[now.getDay()];
    if (!hours) return false;
    var mins = now.getHours() * 60 + now.getMinutes();
    var open = hours.openHour * 60 + hours.openMin;
    var close = hours.closeHour === 24 ? 1440 : hours.closeHour * 60 + hours.closeMin;
    return mins >= open && mins < close;
  }

  // Open store: box asks only for special requests (just the text box).
  // Closed store: box shows the "utan opnunartíma" notice + WhatsApp link.
  function applyStoreState(picker) {
    var open = isStoreOpenNow();
    var timeDD = picker.querySelector('[data-pickup-time-dd]');
    var seroskir = picker.querySelector('[data-pickup-seroskir]');
    if (timeDD) timeDD.hidden = open;
    if (seroskir) seroskir.hidden = !open;
  }

  function fillAll() {
    document.querySelectorAll('[data-olfong-picker]').forEach(applyStoreState);
    document.querySelectorAll('[data-olfong-picker]').forEach(fillPicker);
    // Restore the customer's saved consent + comment + time from the order note,
    // then write the note back — so re-renders (e.g. after adding a product)
    // never lose what they typed/checked.
    restoreFromCart();
  }

  function syncFrom(sourcePicker) {
    var sd = sourcePicker.querySelector('[data-pickup-date]');
    var st = sourcePicker.querySelector('[data-pickup-time]');
    var sc = sourcePicker.querySelector('[data-pickup-consent]');
    var sb = sourcePicker.querySelector('[data-pickup-back]');
    var sn = sourcePicker.querySelector('[data-pickup-note]');
    document.querySelectorAll('[data-olfong-picker]').forEach(function(p) {
      if (p === sourcePicker) return;
      var d = p.querySelector('[data-pickup-date]');
      var c = p.querySelector('[data-pickup-consent]');
      var b = p.querySelector('[data-pickup-back]');
      var n = p.querySelector('[data-pickup-note]');
      if (d && sd) d.value = sd.value;
      if (st) setTimeInPicker(p, st.value);
      if (c && sc) c.checked = sc.checked;
      if (b && sb) b.checked = sb.checked;
      if (n && sn) n.value = sn.value;
      var activePreset = sourcePicker.querySelector('[data-preset].is-active');
      p.querySelectorAll('[data-preset]').forEach(function(b) {
        b.classList.toggle('is-active', activePreset && b.dataset.preset === activePreset.dataset.preset);
      });
    });
  }

  function restoreFromCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var note = cart.note || '';
        var dateMatch = note.match(/Pickup date:\s*(\d{4}-\d{2}-\d{2})/);
        var timeMatch = note.match(/Pickup time:\s*(\d{1,2}:\d{2})/);
        var consentMatch = note.match(/Age & terms confirmed:\s*yes/);
        var backMatch = note.match(/Sækja bakvið:\s*JÁ/);
        var commentMatch = note.match(/Comment:\s*([\s\S]*)$/);
        if (consentMatch) document.querySelectorAll('[data-pickup-consent]').forEach(function(c) { c.checked = true; });
        document.querySelectorAll('[data-olfong-picker]').forEach(function(p) {
          var d = p.querySelector('[data-pickup-date]');
          var b = p.querySelector('[data-pickup-back]');
          var n = p.querySelector('[data-pickup-note]');
          if (d && dateMatch) d.value = dateMatch[1];
          if (timeMatch) setTimeInPicker(p, timeMatch[1]);
          if (b && backMatch) b.checked = true;
          if (n && commentMatch) n.value = commentMatch[1].trim();
          // Always refresh so the checkout-block state is evaluated on load.
          updateUI(p);
        });
        refreshGate();
      })
      .catch(function() {});
  }

  function init() {
    // Only pre-block checkout if a consent CHECKBOX is actually present (legacy
    // gated mode). With the passive age notice there is no checkbox, so checkout
    // is never blocked.
    if (document.querySelector('[data-pickup-consent]')) document.body.classList.add('olfong-pickup-blocked');
    // Only hit /cart.js on load if a picker/consent is actually on the page
    // (the cart page). On other pages it fills lazily when the cart drawer opens.
    if (document.querySelector('[data-olfong-picker], [data-pickup-consent]')) fillAll();
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-preset]');
    if (!btn) return;
    e.preventDefault();
    var picker = btn.closest('[data-olfong-picker]');
    if (!picker) return;
    var minutesAhead = parseInt(btn.dataset.preset, 10);
    var target = new Date();
    target.setMinutes(target.getMinutes() + minutesAhead);
    target = roundUpToFive(target);
    target = clampToOpeningHours(target);
    var d = picker.querySelector('[data-pickup-date]');
    if (d) d.value = formatDate(target);
    setTimeInPicker(picker, formatTime(target));
    picker.querySelectorAll('[data-preset]').forEach(function(b) {
      b.classList.toggle('is-active', parseInt(b.dataset.preset, 10) === minutesAhead);
    });
    syncFrom(picker);
    updateUI(picker);
  });

  // Save the free-text comment as the customer types (debounced), so it's stored
  // even if they hit checkout without blurring the field.
  var olfNoteTimer;
  document.addEventListener('input', function(e) {
    if (!e.target.matches('[data-pickup-note]')) return;
    var picker = e.target.closest('[data-olfong-picker]');
    if (!picker) return;
    clearTimeout(olfNoteTimer);
    olfNoteTimer = setTimeout(function() { syncFrom(picker); updateUI(picker); }, 400);
  });

  document.addEventListener('change', function(e) {
    // Consent lives outside the box now — sync every consent box + refresh gate.
    if (e.target.matches('[data-pickup-consent]')) {
      var val = e.target.checked;
      document.querySelectorAll('[data-pickup-consent]').forEach(function(c) { c.checked = val; });
      var box = document.querySelector('[data-olfong-picker]');
      if (box) updateUI(box); else refreshGate();
      return;
    }
    var picker = e.target.closest('[data-olfong-picker]');
    if (!picker) return;
    if (e.target.matches('[data-pickup-hour], [data-pickup-minute]')) {
      var hourSelect = picker.querySelector('[data-pickup-hour]');
      var minSelect = picker.querySelector('[data-pickup-minute]');
      var timeInput = picker.querySelector('[data-pickup-time]');
      if (timeInput && hourSelect && minSelect) {
        timeInput.value = hourSelect.value + ':' + minSelect.value;
      }
      picker.querySelectorAll('[data-preset]').forEach(function(b) { b.classList.remove('is-active'); });
      syncFrom(picker);
      updateUI(picker);
      return;
    }
    if (e.target.matches('[data-pickup-date], [data-pickup-time], [data-pickup-back]')) {
      if (e.target.matches('[data-pickup-date], [data-pickup-time]')) {
        picker.querySelectorAll('[data-preset]').forEach(function(b) { b.classList.remove('is-active'); });
      }
      syncFrom(picker);
      updateUI(picker);
    }
  });

  // Block checkout ONLY if missing consent or missing date/time.
  // Time outside opening hours is allowed (just a warning).
  document.addEventListener('click', function(e) {
    var t = e.target.closest('#checkout, button[name="checkout"], a[href*="/checkout"], .shopify-payment-button button');
    if (!t) return;
    var consents = document.querySelectorAll('[data-pickup-consent]');
    if (!consents.length) return; // no consent box on page → don't block checkout
    var anyConsent = false;
    consents.forEach(function(c) { if (c.checked) anyConsent = true; });
    if (anyConsent) return; // consent given → let checkout proceed
    // Not confirmed → block, scroll to the (visible) consent box, flash it, and
    // move focus to the checkbox so it's obvious what to do next.
    e.preventDefault();
    e.stopPropagation();
    var target = null;
    document.querySelectorAll('[data-pickup-consent-wrap]').forEach(function(w) { if (w.offsetParent !== null) target = w; });
    if (!target) target = document.querySelector('[data-pickup-consent-wrap]');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.classList.remove('olf-consent-flash');
      void target.offsetWidth; // reflow so the animation replays on every attempt
      target.classList.add('olf-consent-flash');
      var cb = target.querySelector('[data-pickup-consent]');
      if (cb) { try { cb.focus({ preventScroll: true }); } catch (err) { try { cb.focus(); } catch (err2) {} } }
    }
    refreshGate();
  }, true);

  var obsPending = false;
  var observer = new MutationObserver(function() {
    if (obsPending) return; // coalesce bursts of mutations into one rAF pass
    obsPending = true;
    requestAnimationFrame(function() {
      obsPending = false;
      var needsFill = false;
      document.querySelectorAll('[data-olfong-picker]').forEach(function(p) {
        var d = p.querySelector('[data-pickup-date]');
        var t = p.querySelector('[data-pickup-time]');
        if (d && t && (!d.value || !t.value)) needsFill = true;
      });
      if (needsFill) fillAll();
    });
  });

  function startObserving() {
    init();
    observer.observe(document.body, { childList: true, subtree: true });

    // Listen for cart drawer / update events (covers late-injected pickers;
    // replaces the old 1s×10 polling loop).
    document.addEventListener('cart-drawer:opened', fillAll);
    document.addEventListener('cart:updated', fillAll);
    document.addEventListener('cart-items:update', fillAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();
